<template>
  <div>
    <BaseLoading
      v-if="isLoading"
      full-screen
    />
    <BaseInput
      v-model="$v.email.$model"
      :form="$v.email"
      type="email"
      :label="$t('email')"
      @keyup.enter.native="handleLoginSubmit"
    />
    <BaseInput
      v-model="$v.password.$model"
      :form="$v.password"
      type="password"
      :label="$t('password')"
      @keyup.enter.native="handleLoginSubmit"
    />

    <BaseButton
      is-rounded
      class="d-block my-4"
      :is-disabled="$v.$invalid"
      @click="handleLoginSubmit"
    >
      {{ $t('log-me-in') }}
    </BaseButton>

    <b-col
      :cols="12"
      class="d-flex justify-content-center"
    >
      <SocialiteButtons @click="isLoading=true" />
    </b-col>

    <b-row>
      <b-col
        :cols="12"
        class="d-flex flex-column align-items-center"
      >
        <BaseLink
          :text="$t('dont-have-an-account')"
          :to="{name: 'register'}"
        />
        <BaseLink
          class="pt-2"
          :text="$t('did-you-forgot-your-password')"
          :to="{name: 'forgotten-password'}"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import BaseInput from '@/components/Atoms/Form/BaseInput'
import BaseLink from '@/components/Atoms/BaseLink'
import BaseButton from '@/components/Atoms/BaseButton'
import BaseLoading from '@/components/Atoms/BaseLoading'
import SocialiteButtons from '@/pages/Auth/Components/SocialiteButtons'

export default {
  components: {
    SocialiteButtons,
    BaseLoading,
    BaseButton,
    BaseLink,
    BaseInput,
  },
  mixins: [
    validationMixin,
  ],
  props: {},
  metaInfo() {
    return {
      title: this.$t('page-titles.login'),
      meta: [
        { name: 'description', content: this.$t('page-descriptions.login') },
      ],
    }
  },
  data() {
    return {
      email: null,
      password: null,
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      isLoginProcessing: state => state['auth/login'].isLoginProcessing,
    }),
  },
  methods: {
    ...mapActions({
      postLogin: 'auth/login/postLogin',
    }),
    handleLoginSubmit() {
      this.$v.$touch()
      if (!this.$v.$anyError) {
        this.isLoading = true
        this.postLogin({
          email: this.email,
          password: this.password,
        }).then((res) => {
          this.isLoading = false
          if (res && res.token) {
            this.$router.push({
              name: 'home',
            })
          }
        })
      }
    },
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
}
</script>
